import React from 'react';

const FormSection = ({ title, children, columns = 3, className = '', extra = null, fields = null, renderFields }) => (
  <div className={`form-section ${className}`.trim()}>
    {title !== 'Container Cargo' && <div className="section-header" style={extra ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } : {}}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className="header-line" />
        <h3>{title}</h3>
      </div>
      {extra}
    </div>}
    {fields ? renderFields(fields) : (
      <div className={className === 'workorderinfo' ? `${className}` : `form-grid columns-${columns}`}>
        {children}
      </div>
    )}
  </div>
);

export default FormSection;
